<template>
	<div>
		<header class="flex-apart">
			<h1 class="alpha heavy">Missed Leads</h1>
		</header>
		<div>
			<loader v-if="!loaded"/>
			<div v-if="loaded" class="section--floating">
				<table-filter :filters="filters"/>
				<div v-if="!items.length" class="nothing-to-see-here">
					<p>Nothing to display.</p>
				</div>
				<v-table v-if="items.length" :loading="gettingModels">
					<thead>
						<tr>
							<th align="left">Client</th>
							<th align="left">Service</th>
							<th align="left">Source</th>
							<th align="left">Date</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</thead>
					<tfoot>
						<tr>
							<th align="left">Client</th>
							<th align="left">Service</th>
							<th align="left">Source</th>
							<th align="left">Date</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</tfoot>
					<tbody>
						<tr v-for="(item, index) in items">
							<td v-html="$present('clientName', item.client)"/>
							<td v-html="item.service.names.singular"/>
							<td v-html="item.introduction.service_provider.profile.name"/>
							<td v-html="$present('dateTime', item.created_at)"></td>
							<td align="right">
								<v-contextual>
									<!--									<v-contextual-option-->
									<!--										v-if="$can('view', item)"-->
									<!--										:route-to="{name: 'missedLeads.show', params: {missedLead: item.id}}">View</v-contextual-option>-->
									<v-contextual-option
										v-if="$can('assign', item)"
										@click="showAssignLeadModal(item)">Assign</v-contextual-option>
								</v-contextual>
							</td>
						</tr>
					</tbody>
				</v-table>
				<paginator :links="links" :meta="meta"/>
			</div>
		</div>
	</div>
</template>
<script>
import Index from "../../../../components";

let index = new Index("missedLeads");

export default {

	computed: {
		...index.computed(),
	},

	methods: {
		...index.actions(),
		showAssignLeadModal(missedLead) {
			this.$vmodal.open({
				component: require("./modals/Assign.vue").default,
				props: {
					lead: missedLead,
				},
			});
		},
	},

	created() {
		this.filter(this.$router.currentRoute.query);
	},
};
</script>
